module.exports = __webpack_public_path__ + "static/media/RPS-animated.637d74ff.gif";